import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { notBlankValidation, priceValidation } from '../../../utils/validations';
import Input from '../../shared/input/Input';

const PartForm = ({ onSubmit, initPart = {}, readOnly, loading }) => {
  const methods = useForm({ defaultValues: initPart });
  return (
    <FormProvider {...methods}>
      <form id="part-form" noValidate className="modal-form" onSubmit={methods.handleSubmit((data) => onSubmit(data))}>
        <Input
          label="Назва деталі"
          type="input"
          name="name"
          autoFocus="true"
          disabled={readOnly || loading}
          placeholder={'Введіть назву деталі'}
          validation={notBlankValidation}
        />
        <Input
          label="Ціна деталі"
          type="number"
          name="price"
          disabled={readOnly || loading}
          placeholder={'Введіть ціну деталі'}
          validation={priceValidation}
        />
      </form>
    </FormProvider>
  );
};

export default PartForm;
